import AuthenticatedOnboarding from './AuthenticatedOnboarding';
import './AuthenticatedOnboarding.scss';

export default AuthenticatedOnboarding;
